var _defs, _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew196({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.61,
    width: 4.3,
    height: 8.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 11.2,
    y: 3.61,
    width: 4.3,
    height: 8.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.61,
    width: 15,
    height: 8.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,5.59a.78.78,0,1,0-.78-.77h0A.78.78,0,0,0,9,5.59ZM7.59,11,8,9.27l.81.77v2.32h.78V9.46l-.82-.77L9,7.52a2.79,2.79,0,0,0,2.12,1V7.72a1.91,1.91,0,0,1-1.66-.93l-.39-.62a.79.79,0,0,0-.65-.39c-.12,0-.2,0-.31,0l-2,.85V8.49h.78V7.18l.7-.27L6.94,10,5,9.65l-.15.78,2.7.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew196);
export default __webpack_public_path__ + "static/media/Symbolpack_New_196.9149261b8d16bf0c49b39ebd709896d8.svg";
export { ForwardRef as ReactComponent };